// Ready is the lifecycle name used everywhere else in Console. Accept the
// former "undeployed" token as well so a drag already in progress across a
// rolling frontend update is not discarded.
export const isReadySurveyDragPayload = (payload) => (
    payload?.type === 'survey'
    && (payload.status === 'ready' || payload.status === 'undeployed')
);
